import React from 'react'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@material-ui/styles'
import {
  IconButton,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip
} from '@material-ui/core'
import LanguageIcon from '@material-ui/icons/Language'
import { Analytics } from '../../utils'
import { dutch, french } from '../../i18n/languages'

const useStyles = makeStyles(theme => ({
  menuItem: {
    '&:focus': {
      backgroundColor: theme.palette.primary.main,
      color: 'white'
    },
    '&.Mui-selected:focus': {
      backgroundColor: theme.palette.primary.main,
      color: 'white'
    }
  },
  menuPaper: {
    boxShadow: theme.customShadows.primary.dark[1],
  },
}))


const LanguagePicker = () => {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = React.useState(null)
  const { i18n, t } = useTranslation()

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const changeLanguage = lng => async () => {
    Analytics.buttonClickEvent(`Language Button ${lng}`)
    handleClose()
    if (i18n.language !== lng) {
      i18n.changeLanguage(lng)
    }
  }

  const renderLanguageChoice = ({ code, title }) => {
    const { language } = i18n
    return (
      <MenuItem
        className={classes.menuItem}
        onClick={changeLanguage(code)}
        selected={code === language}
        key={code}
      >
        <ListItemText primary={title} />
      </MenuItem>
    )
  }

  const languageConfig = [
    { code: french, title: 'Français' },
    { code: dutch, title: 'Nederlands' },
  ]

  return (
    <div>
      <Tooltip title={t('tooltips.language')} aria-label="Language">
        <IconButton
          aria-controls="language-menu"
          aria-label="language-menu"
          aria-haspopup="true"
          onClick={handleClick}
        >
          <LanguageIcon />
        </IconButton>
      </Tooltip>

      <Menu
        PopoverClasses={{ paper: classes.menuPaper }}
        id="language-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        {languageConfig.map(renderLanguageChoice)}
      </Menu>
    </div>
  )
}

export default LanguagePicker
